import {Action} from "redux";
import {GetAllEntriesByClientRequest} from "../request/entry_request";
import {GetAllEntriesByClientResponse} from "../response/entry_response";

export enum ClientEntriesActionType {
    REQUEST_GET_ALL_ENTRY_LIST = "CLIENT_ENTRIES_REQUEST_GET_ALL_ENTRY_LIST",
    CALLBACK_GET_ALL_ENTRY_LIST = "CLIENT_ENTRIES_CALLBACK_GET_ALL_ENTRY_LIST",

}

export interface IRequestGetAllEntriesAction extends Action {
    type: ClientEntriesActionType.REQUEST_GET_ALL_ENTRY_LIST;
    item: GetAllEntriesByClientRequest,
}

export interface ICallbackGetAllEntriesAction extends Action {
    type: ClientEntriesActionType.CALLBACK_GET_ALL_ENTRY_LIST;
    isSuccess: boolean;
    item?: GetAllEntriesByClientResponse;
    error?: any;
}

export type ClientEntriesAction =
    IRequestGetAllEntriesAction |
    ICallbackGetAllEntriesAction ;

export interface IClientEntriesActionCreator {
    requestGetAllEntriesAction(
        item: GetAllEntriesByClientRequest,
    ): IRequestGetAllEntriesAction;

    callbackGetAllEntriesAction(
        isSuccess: boolean,
        item?: GetAllEntriesByClientResponse,
        error?: any,
    ): ICallbackGetAllEntriesAction;
}

class ActionCreator implements IClientEntriesActionCreator {
    public requestGetAllEntriesAction = (
        item: GetAllEntriesByClientRequest,
    ): IRequestGetAllEntriesAction => {
        return {
            type: ClientEntriesActionType.REQUEST_GET_ALL_ENTRY_LIST,
            item,
        };
    };

    public callbackGetAllEntriesAction = (
        isSuccess: boolean,
        item: GetAllEntriesByClientResponse,
        error?: any,
    ): ICallbackGetAllEntriesAction => {
        return {
            type: ClientEntriesActionType.CALLBACK_GET_ALL_ENTRY_LIST,
            isSuccess,
            item,
            error,
        };
    };
}

export const createClientEntriesActionCreator = (): IClientEntriesActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_entries_action.ts